module.exports = __webpack_public_path__ + "static/media/whather_bg.afc4c383.jpg";